export default "__VITE_ASSET__by5IE9we__"